import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LinearProgress } from '@mui/material';

import { useSnackbar } from 'notistack';

import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';

import { FlightOperationNotification, FlightLookup, FlightEventFlightDetailsLookup } from '../../core/api/clients';

import FlightLookupForm from '../../components/FlightLookupForm';
import useCreateNewFlightOperationNotification from '../../core/api/hooks/flight-operation/useCreateNewFlightOperationNotification';
import FlightOperationNotificationNewOptions from './FlightOperationNotificationNewOptions';

function FlightOperationNotificationNew() {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmit, setIsSubmit] = React.useState<boolean>(false);
  const [cssCreate, setCssCreate] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [flightSegments, setFlightSegments] = React.useState<FlightOperationNotification[]>([]);

  const authorizedFormData = useAuthorizedFormData();
  const { mutate: createFlightOperationNotification, status: createFlightOperationNotificationStatus } = useCreateNewFlightOperationNotification();

  const handleCreateFlightOperationNotification = (flightDetailsLookup: FlightEventFlightDetailsLookup) => {
    createFlightOperationNotification(flightDetailsLookup, {
      onSuccess: (flightOperationNotifications: FlightOperationNotification[]) => {
        if (flightOperationNotifications.length === 1) {
          navigate(`${authorizedFormData.metadata?.route}/${flightOperationNotifications[0].id}/edit`, { replace: true });
        } else {
          setFlightSegments(flightOperationNotifications);
        }
      },
      onError: () => enqueueSnackbar('Flight not found', {
        variant: 'warning',
      }),
    });
  };

  React.useEffect(() => {
    if (searchParams.has('cssLegId')) {
      const cssLegId = searchParams.get('cssLegId');
      if (cssLegId !== null) {
        setCssCreate(true);
        handleCreateFlightOperationNotification({ cssLegId });
      }
    }
  }, [searchParams]);

  const onSubmit = (flightLookup: FlightLookup) => {
    setIsSubmit(true);
    handleCreateFlightOperationNotification({ flightLookup });
  };
  const onCancel = () => navigate(authorizedFormData.metadata?.route ?? '');
  const onBlank = () => {
    setIsSubmit(false);
    handleCreateFlightOperationNotification({});
  };

  if (cssCreate && createFlightOperationNotificationStatus === 'pending') {
    return (
      <LinearProgress />
    );
  }

  return (
    <React.Fragment>
      <FlightLookupForm
        onSubmit={onSubmit}
        onCancel={onCancel}
        onBlank={onBlank}
        color={authorizedFormData.metadata?.color}
        loading={isSubmit && createFlightOperationNotificationStatus === 'pending'}
        isDateDefault
      />
      <FlightOperationNotificationNewOptions
        data={flightSegments}
      />
    </React.Fragment>
  );
}

export default FlightOperationNotificationNew;
